import { render, staticRenderFns } from "./submitDialog.vue?vue&type=template&id=25cbf1bc&"
import script from "./submitDialog.vue?vue&type=script&lang=js&"
export * from "./submitDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports